export const getOrganizationMediaSource = (type: number): string => {
    return `${process.env.REACT_APP_API_URL}/media/organization/${type}/data`;
};

export const getFormLogoSource = (url: string): string => {
    return `${process.env.REACT_APP_API_URL}/media/common/${url}/data`;
};
